export default __webpack_public_path__ + "static/media/honeycombleft.2f1ae429.png";